import $ from 'jquery';
import globalScope from 'core/globalScope';

const window = globalScope.window;
export default {
  // Permet de savoir quand on bascule en mode petit ecran, sur les pages responsives et contenant la div cadremploi uniquement.
  isXsScreen: function() {
    return $(window).width() < 768;
  },

  isSmallScreen: function() {
    if (typeof globalScope.window.getComputedStyle === 'undefined') {
      return false;
    }
    const cadremploi = $('.cadremploi');
    if (cadremploi.length === 0) {
      return false;
    }

    const cadremploiAfterContent = globalScope.window
      .getComputedStyle(cadremploi.get(0), ':after')
      .getPropertyValue('content');
    return cadremploiAfterContent.indexOf('smallscreen') !== -1;
  }
};
